import React from 'react';
import { useRouter } from 'next/dist/client/router';
import useLinkAccountInfo from '@/src/hooks/useLinkAccountInfo';

const LinkTokenDetector = () => {
  const router = useRouter();
  const { setData } = useLinkAccountInfo();

  React.useEffect(() => {
    if (!router.isReady) {
      return;
    }
    const linkToken = router.query.linkToken as string | undefined;
    const appointmentId = router.query.appointmentId as string | undefined;
    const documentId = router.query.documentId as string | undefined;
    const sncfIdentifier = router.query.sncfIdentifier as string | undefined;
    if (linkToken) {
      setData(linkToken, { appointmentId, documentId, sncfIdentifier });
    }
  }, [router.isReady]);

  return null;
};
export default LinkTokenDetector;
